import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import Grid from "@mui/material/Grid";
import { Container, Form } from "react-bootstrap";
import { Box, Button, Table, Input } from "@mui/material";
import Moment from "moment";
import jsPDF from "jspdf";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "jspdf-autotable";
import moment from "moment";
import axios from "../../Uri";
import { GetAllBuildings ,CurrentMonthCheckout} from "../downloadData/Urls";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { DownloadTableExcel } from "react-export-table-to-excel";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
const ArchiveByDate = () => {
  const [startDate, setStartDate] = useState("");
  const [payment, setPayment] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [selected, setSelected] = React.useState("");
  const [building, setBuilding] = React.useState([]);
  const [buildingId, setbuildingId] = React.useState(null);
  const [currentVacate,setCurrentVacated] = React.useState([]);
  console.log(buildingId);
  console.log(building);

  const columns = [
    {
        title: "Guest Name",
        field: "firstName",
        type: "text",
        headerStyle: {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    },
    {
        title: "checkOutDate",
        field: "checkOutDate",
        type: "date",
        dateSetting: { locale: "en-GB" },
        headerStyle: {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    },
    {
        title: "guestStatus ",
        field: "guestStatus",
        headerStyle: {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    },
    {
        title: "Building Name",
        field: "buildingName",
        type: "text",
        headerStyle: {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    },
    {
        title: "Guest ID",
        field: "id",
        type: "text",
        headerStyle: {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    },
    {
        title: "Phone Number",
        field: "personalNumber",
        headerStyle: {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    },
    {
        title: "Bed ID",
        field: "bedId",
        headerStyle: {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    },
];


//monthly data 
const columns2 = [
  {
      title: "Guest Name",
      field: "firstName",
      type: "text",
      headerStyle: {
          backgroundColor: "#1E90FF",
          color: "white",
      },
  },
  {
      title: "checkOutDate",
      field: "checkOutDate",
      type: "date",
      dateSetting: { locale: "en-GB" },
      headerStyle: {
          backgroundColor: "#1E90FF",
          color: "white",
      },
  },
  {
      title: "guestStatus ",
      field: "guestStatus",
      headerStyle: {
          backgroundColor: "#1E90FF",
          color: "white",
      },
  },
  {
      title: "Building Name",
      field: "buildingName",
      type: "text",
      headerStyle: {
          backgroundColor: "#1E90FF",
          color: "white",
      },
  },
  {
      title: "Guest ID",
      field: "id",
      type: "text",
      headerStyle: {
          backgroundColor: "#1E90FF",
          color: "white",
      },
  },
  {
      title: "Phone Number",
      field: "personalNumber",
      headerStyle: {
          backgroundColor: "#1E90FF",
          color: "white",
      },
  },
  {
      title: "Bed ID",
      field: "bedId",
      headerStyle: {
          backgroundColor: "#1E90FF",
          color: "white",
      },
  },
];


  const tableRef = useRef(null);
  const GetDataSheet = () => {
    axios
      .get(
        `/guest/findGuestAreVacated/vacated/${buildingId}?field=checkOutDate&fromDate=${startDate}&toDate=${endDate}`
      )
      .then((response) => {
        console.log(response);
        console.log(response.data);
        setPayment(response.data);
        // if (response.data.status == true || response.data.data != null) {
        // setPayment(response.data);
        //   console.log(response.data);
        // }
        // else if (response.data.status == false && response.data.data == null) {
        //    console.log("No Records Found");
        //     //   toast.warning(" No Records Found");
        // }
        //?startDate=2022-09-02&endDate=2022-09-08
        //?startDate=${startDate}&endDate=${endDate}
      })
      .catch((error) => {
        console.log(" No Records Found", error);
      });
    // console.log(response.data);
  };

  //current month vacated list .
  const GetCurrentVacatedSheet = () => {
    CurrentMonthCheckout()
      .then((response) => {
        console.log(response);
        console.log(response.data);
        setCurrentVacated(response.data);
      })
      .catch((error) => {
        console.log(" No Records Found", error);
      });
    // console.log(response.data);
  };




  useEffect(() => {
    GetAllBuildings()
      .then((res) => {
        setBuilding(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong🤦‍♂️");
      });
  }, []);
  useEffect(() => {
    GetDataSheet();
  }, []);

  useEffect(() => {
    GetCurrentVacatedSheet();
  }, []);
  console.log(payment);
  console.log(currentVacate);
  return (
   
    <Grid item container spacing={1}>

  <Grid xs={12}>
       
       <MaterialTable
           title="Vacated Guest In Current Month"
           data={currentVacate}
           sx={{ color: "white" }}
           columns={columns}
           options={{
               exportButton: true,
               pageSize: 25,
               actionsColumnIndex: -1,
               grouping: true,
               addRowPosition: "first",
               headerStyle: {
                   backgroundColor: "#1E90FF",
                   color: "white",
                   fontSize: "15px",
                   //height: "10px",
                   //fontWeight: 'bold'
               },
               rowStyle: {
                   fontSize: 16,
               },
           }}
       />

</Grid>
      <Grid item lg={12} md={6} xs={12} marginTop={4}>
      
      

        <label value="Select Building: ">Select Building: </label>
        <Select
          sx={{ minHeight: 44 }}
          style={{ width: "30%", height: "10%" }}
          value={selected}
          name="building"
          IconComponent={() => <ArrowDropDownIcon />}
        >
          {building.map((post) => {
            return (
              <MenuItem
                value={post.buildingName}
                onClick={async () => {
                  setSelected(post.buildingName);
                  console.log(post.buildingId);
                  setbuildingId(post.buildingId);
                }}
              >
                {" "}
                {post.buildingName}{" "}
              </MenuItem>
            );
          })}
        </Select>
        <MDBox
          style={{ padding: "20px", margin: "18px", border: "2px solid maroon",borderRadius:'10px' }}
        >
          <strong>
            {" "}
            <button
              style={{
                fontSize: "17px",
                color: "white",
                border: "2px solid white",
                borderRadius: "4px",
                margin: "22px",
                background: "#419BEF",
                width: "160px",
                height: "30px",
              }}
            >
              Select From Date
            </button>
          </strong>
          <Input
            style={{
              border: "2px solid maroon",
              borderRadius: "3px",
              margin: "4px",
            }}
            type="date"
            onChange={(e) => setStartDate(e.target.value)}
          />
          <strong>
            {" "}
            <button
              style={{
                fontSize: "17px",
                color: "white",
                border: "2px solid white",
                borderRadius: "4px",
                margin: "22px",
                background: "#419BEF",
                width: "160px",
                height: "30px",
              }}
            >
              Select To Date
            </button>
          </strong>
          <Input
            style={{
              border: "2px solid maroon",
              borderRadius: "3px",
              margin: "4px",
            }}
            type="date"
            onChange={(e) => setEndDate(e.target.value)}
          />
          <Button
            type="submit"
            onClick={GetDataSheet}
            style={{
              background: "blue",
              color: "white",
              marginRight: "6px",
              marginLeft: "18px",
              marginTop: "2px",
              padding: "12px",
              width: "120px",
            }}
          >
            Submit
          </Button>
         
        </MDBox>
      </Grid>
      <Grid item lg={12} md={6} xs={12}>
     
      <Grid xs={12}>
                <MaterialTable
                    title="Vacated Guest Data In DashBoard"
                    data={payment}
                    sx={{ color: "white" }}
                    columns={columns}
                    options={{
                        exportButton: true,
                        pageSize: 50,
                        actionsColumnIndex: -1,
                        grouping: true,
                        addRowPosition: "first",
                        headerStyle: {
                            backgroundColor: "#1E90FF",
                            color: "white",
                            fontSize: "15px",
                            //height: "10px",
                            //fontWeight: 'bold'
                        },
                        rowStyle: {
                            fontSize: 16,
                        },
                    }}
                />
        </Grid>
    </Grid>
    </Grid>
  );
};
export default ArchiveByDate;